export function FeatureCard({ icon: Icon, title, description }) {
  return (
    <div className="group rounded-xl border border-hair bg-white p-6 shadow-sm transition-all duration-300 hover:border-finblue/30 hover:shadow-md">
      <span className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-canvas text-finblue transition-colors duration-300 group-hover:bg-navy group-hover:text-gold">
        <Icon className="h-6 w-6" strokeWidth={1.5} />
      </span>
      <h3 className="mt-5 font-heading text-lg font-semibold text-ink">{title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-subtle">{description}</p>
    </div>
  );
}
